import type { TFunction } from "i18next";

const formatDuration = (start: Date, end: Date, t: TFunction): string => {
    const total = Math.max(
        0,
        Math.round(
            (new Date(end).getTime() - new Date(start).getTime()) / 60000,
        ),
    );
    const hours = Math.floor(total / 60);
    const minutes = total % 60;

    if (hours === 0) return t("vistassistant.duration.minutes", { minutes });
    if (minutes === 0) return t("vistassistant.duration.hours", { hours });

    return t("vistassistant.duration.hoursMinutes", {
        hours,
        minutes: String(minutes).padStart(2, "0"),
    });
};

export default formatDuration;
